/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_ResumesInputs */

const en_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumes`)
};

const de_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensläufe`)
};

const fr_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums`)
};

const it_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum`)
};

const nl_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV's`)
};

const pl_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Życiorysy`)
};

const fi_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elämäkertoja`)
};

const da_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV'er`)
};

const sv_settings_feature_resumes = /** @type {(inputs: Settings_Feature_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resumes" |
*
* @param {Settings_Feature_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_resumes = /** @type {((inputs?: Settings_Feature_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_resumes(inputs)
	if (locale === "fr") return fr_settings_feature_resumes(inputs)
	if (locale === "es") return es_settings_feature_resumes(inputs)
	if (locale === "it") return it_settings_feature_resumes(inputs)
	if (locale === "nl") return nl_settings_feature_resumes(inputs)
	if (locale === "pl") return pl_settings_feature_resumes(inputs)
	if (locale === "fi") return fi_settings_feature_resumes(inputs)
	if (locale === "da") return da_settings_feature_resumes(inputs)
	if (locale === "sv") return sv_settings_feature_resumes(inputs)
	return en_settings_feature_resumes(inputs)
});